import React from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  FacebookShareCount,
  TwitterShareButton,
  XIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TelegramShareButton,
  TelegramIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import BannerWithSocialShare from "./SocialShareWall";

const SocialShare = () => {
  const shareUrl = "https://apis.expoplanner.in/share_wall.html";
  const title =
    "Discover IMTEX FORMING 2026: Asia's Largest Metal Forming and Manufacturing Tech Expo";
  const hashtags = ["IMTEX", "Manufacturing", "Expo", "Technology"];

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Modern Header Section 
      
      <div
        style={{
          background: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
          borderRadius: "20px",
          padding: "50px 40px",
          color: "white",
          marginBottom: "40px",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          position: "relative",
          overflow: "hidden",
        }}
      >
      
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "300px",
            height: "300px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
            borderRadius: "50%",
            transform: "translate(100px, -100px)",
          }}
        ></div>

        <div style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "30px",
            }}
          >
           
            <div style={{ flex: "1", minWidth: "300px" }}>
              <div
                style={{
                  display: "inline-block",
                  background: "rgba(255,255,255,0.15)",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "20px",
                  backdropFilter: "blur(10px)",
                }}
              >
                🚀 Asia's Premier Manufacturing Expo
              </div>

              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "800",
                  marginBottom: "15px",
                  lineHeight: "1.2",
                  background: "linear-gradient(45deg, #fff, #e0f2fe)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                IMTEX FORMING 2026
              </h1>

              <h2
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "600",
                  marginBottom: "25px",
                  opacity: "0.9",
                  lineHeight: "1.4",
                }}
              >
                International Exhibition on Machine Tools & Manufacturing
                Technology
              </h2>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "30px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      background: "#10b981",
                      borderRadius: "50%",
                      animation: "pulse 2s infinite",
                    }}
                  ></div>
                  <span style={{ fontSize: "16px", fontWeight: "500" }}>
                    Bangalore International Exhibition Centre
                  </span>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <div style={{ fontSize: "18px" }}>📅</div>
                  <span style={{ fontSize: "16px", fontWeight: "500" }}>
                    January 2026
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "inline-flex",
                  background: "rgba(255,255,255,0.1)",
                  padding: "12px 24px",
                  borderRadius: "12px",
                  fontSize: "15px",
                  fontWeight: "500",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                🎯 500+ Exhibitors • 50,000+ Visitors • 30+ Countries
              </div>
            </div>

          
            <div
              style={{
                background: "rgba(255,255,255,0.1)",
                padding: "30px",
                borderRadius: "16px",
                backdropFilter: "blur(15px)",
                border: "1px solid rgba(255,255,255,0.2)",
                minWidth: "280px",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Event Highlights
              </h3>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                {[
                  { icon: "🔧", text: "Metal Forming Technologies" },
                  { icon: "🤖", text: "Industry 4.0 Solutions" },
                  { icon: "📊", text: "Digital Manufacturing" },
                  { icon: "🌱", text: "Sustainable Technologies" },
                  { icon: "💡", text: "Live Demonstrations" },
                ].map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "8px 0",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}>{item.icon}</span>
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {item.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          marginBottom: "40px",
        }}
      >
        {[
          {
            icon: "🏭",
            title: "Comprehensive Showcase",
            description:
              "Latest innovations in machine tools and manufacturing technology",
          },
          {
            icon: "🌍",
            title: "Global Participation",
            description:
              "International exhibitors and visitors from across the globe",
          },
          {
            icon: "📈",
            title: "Business Opportunities",
            description: "Networking with industry leaders and decision makers",
          },
          {
            icon: "🎓",
            title: "Knowledge Exchange",
            description: "Technical conferences and knowledge-sharing sessions",
          },
        ].map((feature, index) => (
          <div
            key={index}
            style={{
              background: "#f8fafc",
              padding: "30px 25px",
              borderRadius: "16px",
              textAlign: "center",
              border: "1px solid #e2e8f0",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>
              {feature.icon}
            </div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "700",
                marginBottom: "12px",
                color: "#1e293b",
              }}
            >
              {feature.title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#64748b",
                lineHeight: "1.5",
              }}
            >
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      {/* Share Section */}
      <div
        style={{
          background: "white",
          padding: "40px",
          borderRadius: "20px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          border: "1px solid #f1f5f9",
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "700",
            marginBottom: "15px",
            color: "#1e293b",
            textAlign: "center",
          }}
        >
          Spread the Word!
        </h3>

        <p
          style={{
            fontSize: "16px",
            color: "#64748b",
            textAlign: "center",
            marginBottom: "30px",
            lineHeight: "1.6",
          }}
        >
          Share this exciting expo with your network and join the conversation
          about cutting-edge manufacturing technologies!
        </p>

        {/* Share Buttons */}
        <div
          style={{
            display: "flex",
            gap: "16px",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Facebook */}
          <div style={{ textAlign: "center" }}>
            <FacebookShareButton url={shareUrl} quote={title} hashtag="#IMTEX">
              <FacebookIcon size={48} round />
            </FacebookShareButton>
            <FacebookShareCount url={shareUrl}>
              {(count) => (
                <span
                  style={{ fontSize: 12, display: "block", marginTop: "4px" }}
                >
                  {count}
                </span>
              )}
            </FacebookShareCount>
          </div>

          {/* X (formerly Twitter) */}
          <TwitterShareButton url={shareUrl} title={title} hashtags={hashtags}>
            <XIcon size={48} round />
          </TwitterShareButton>

          {/* LinkedIn */}
          <LinkedinShareButton
            url={shareUrl}
            title={title}
            summary="Explore Asia's biggest exhibition on metal forming and manufacturing technologies at IMTEX FORMING 2026!"
            source="IMTEX.in"
          >
            <LinkedinIcon size={48} round />
          </LinkedinShareButton>

          {/* WhatsApp */}
          <WhatsappShareButton url={shareUrl} title={title} separator=" - ">
            <WhatsappIcon size={48} round />
          </WhatsappShareButton>

          {/* Telegram */}
          <TelegramShareButton url={shareUrl} title={title}>
            <TelegramIcon size={48} round />
          </TelegramShareButton>

          {/* Email */}
          <EmailShareButton
            url={shareUrl}
            subject="Discover IMTEX FORMING 2026"
            body="Check out this exciting expo: "
          >
            <EmailIcon size={48} round />
          </EmailShareButton>
        </div>
      </div>

      <BannerWithSocialShare
        bannerImage="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
        title="Amazing Mountain Adventure"
        subtitle="Explore the breathtaking beauty of nature"
        url="https://your-website.com/mountain-adventure"
        description="Join us on an incredible journey through majestic mountains and stunning landscapes. Perfect for adventure seekers and nature lovers."
      />

      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default SocialShare;
